import { DomEvents } from './dom-events';
var MISSING_HAMMER_MESSAGE = 'Hammerjs is not loaded.' +
    'Solution: http://www.telerik.com/kendo-react-ui/components/charts/troubleshooting/#toc-installation';
/**
 * @hidden
 */
var DomEventsBuilder = /** @class */ (function () {
    function DomEventsBuilder() {
    }
    DomEventsBuilder.create = function (element, events) {
        if (typeof window !== 'undefined') {
            var HAMMER = window.Hammer;
            if (!HAMMER) {
                if (process.env.NODE_ENV !== 'production') {
                    console.warn(MISSING_HAMMER_MESSAGE);
                }
                return;
            }
            var hammerInstance = new HAMMER(element, {
                recognizers: [
                    [HAMMER.Tap],
                    [HAMMER.Pan],
                    [HAMMER.Pinch],
                    [HAMMER.Press, { time: 0 }]
                ]
            });
            return new DomEvents(hammerInstance, events);
        }
    };
    return DomEventsBuilder;
}());
export { DomEventsBuilder };
//# sourceMappingURL=dom-events-builder.js.map